import { Typography } from '@design-system';
import React from 'react';
import { AiFillIdcard } from 'react-icons/ai';
import { BiSolidBarChartAlt2, BiSolidChat } from 'react-icons/bi';
import { BsClipboard2CheckFill, BsPersonFillExclamation } from 'react-icons/bs';
import { FaGraduationCap, FaShoppingBasket, FaShoppingCart, FaStar, FaUmbrellaBeach, FaUserLock } from 'react-icons/fa';
import { FaTriangleExclamation } from 'react-icons/fa6';
import { HiClipboardDocumentList, HiMiniDocumentMagnifyingGlass, HiNewspaper } from 'react-icons/hi2';
import { IoBagHandleSharp, IoLibrary, IoNotificationsSharp, IoShieldCheckmarkSharp } from 'react-icons/io5';
import { MdTimer } from 'react-icons/md';
import { PiMedalFill } from 'react-icons/pi';
import { RiQuillPenFill } from 'react-icons/ri';

export const pageTitles: Record<
    string,
    {
        title?: string;
        titleElement?: React.ReactNode;
        hasFavorite?: boolean;
        customNavigate?: string;
        hideHeader?: boolean;
    }
> = {
    '/': {
        hideHeader: true
    },
    '/company-choice': {
        hideHeader: true
    },
    '/company-choice/': {
        hideHeader: true
    },
    '/home': { title: 'Dashboard' },
    '/news': {
        titleElement: (
            <>
                <Typography intrinsic="h3" iconColor="green" icon={<HiNewspaper />} iconFilled iconSize={20}>
                    Actualités
                </Typography>
            </>
        )
    },
    '/signature': { title: 'Signature' },
    '/signature/update': {
        titleElement: (
            <>
                <Typography intrinsic="h3" iconColor="green" icon={<RiQuillPenFill />} iconFilled iconSize={20}>
                    Signature
                </Typography>
            </>
        )
    },
    '/login': {
        titleElement: (
            <>
                <Typography intrinsic="h3" iconColor="green" icon={<FaUserLock />} iconFilled iconSize={20}>
                    Connexion
                </Typography>
            </>
        ),
        customNavigate: '/company-choice'
    },
    '/notifications': {
        titleElement: (
            <>
                <Typography intrinsic="h3" iconColor="green" icon={<IoNotificationsSharp />} iconFilled iconSize={20}>
                    Notifications
                </Typography>
            </>
        ),
        customNavigate: '/home'
    },
    '/design-system': { title: 'Design System' },
    '/event-feedback': {
        titleElement: (
            <Typography intrinsic="h3" iconColor="green" icon={<FaTriangleExclamation />} iconFilled iconSize={20}>
                Remontée d'évènement
            </Typography>
        )
    },
    '/richesses-humaines': {
        titleElement: <Typography intrinsic="h2">Richesses humaines</Typography>,
        customNavigate: '/home'
    },
    '/richesses-humaines/pointage': {
        titleElement: (
            <>
                <Typography intrinsic="h3" iconColor="yellow" icon={<MdTimer />} iconFilled iconSize={20}>
                    Pointage
                </Typography>
            </>
        ),
        hasFavorite: true,
        customNavigate: '/richesses-humaines'
    },
    '/richesses-humaines/bibliotheque': {
        titleElement: (
            <Typography intrinsic="h3" iconColor="yellow" icon={<IoLibrary />} iconFilled iconSize={20}>
                Bibliothèque RH
            </Typography>
        ),
        hasFavorite: true,
        customNavigate: '/richesses-humaines'
    },
    '/richesses-humaines/conges': {
        titleElement: (
            <Typography intrinsic="h3" iconColor="yellow" icon={<FaUmbrellaBeach />} iconFilled iconSize={20}>
                Demandes d'absence
            </Typography>
        ),
        hasFavorite: true,
        customNavigate: '/richesses-humaines'
    },
    '/richesses-humaines/carte-btp': {
        titleElement: (
            <Typography intrinsic="h3" iconColor="yellow" icon={<AiFillIdcard />} iconFilled iconSize={20}>
                Carte BTP
            </Typography>
        ),
        hasFavorite: true,
        customNavigate: '/richesses-humaines'
    },
    '/richesses-humaines/conges/new': {
        titleElement: (
            <Typography intrinsic="h3" iconColor="yellow" icon={<FaUmbrellaBeach />} iconFilled iconSize={20}>
                Nouvelle demande d'absence
            </Typography>
        ),
        customNavigate: '/richesses-humaines/conges'
    },
    '/richesses-humaines/conges/:holidayId': {
        titleElement: (
            <Typography intrinsic="h3" iconColor="yellow" icon={<FaUmbrellaBeach />} iconFilled iconSize={20}>
                Modifier une demande d'absence
            </Typography>
        ),
        customNavigate: '/richesses-humaines/conges'
    },
    '/richesses-humaines/event-feedback': {
        titleElement: (
            <Typography intrinsic="h3" iconColor="yellow" icon={<BsPersonFillExclamation />} iconFilled iconSize={20}>
                Remontées RH
            </Typography>
        ),
        customNavigate: '/richesses-humaines'
    },
    '/sante-securite': {
        titleElement: <Typography intrinsic="h2">Santé et sécurité au travail</Typography>,
        customNavigate: '/home'
    },
    '/sante-securite/bibliotheque': {
        titleElement: (
            <Typography intrinsic="h2" iconColor="blue" icon={<IoLibrary />} iconFilled iconSize={20}>
                Bibliothèque sécurité
            </Typography>
        ),
        hasFavorite: true,
        customNavigate: '/sante-securite'
    },
    '/sante-securite/event-feedback': {
        titleElement: (
            <Typography intrinsic="h3" iconColor="blue" icon={<FaTriangleExclamation />} iconFilled iconSize={20}>
                Remontée d'évènement
            </Typography>
        ),
        customNavigate: '/sante-securite'
    },
    '/sante-securite/causeries': {
        titleElement: (
            <Typography intrinsic="h3" iconColor="blue" icon={<BiSolidChat />} iconFilled iconSize={20}>
                Causeries
            </Typography>
        ),
        customNavigate: '/sante-securite'
    },
    '/sante-securite/causeries/list': {
        titleElement: (
            <Typography intrinsic="h3" iconColor="blue" icon={<BiSolidChat />} iconFilled iconSize={20}>
                Causeries
            </Typography>
        ),
        hasFavorite: true,
        customNavigate: '/sante-securite'
    },
    '/sante-securite/formations': {
        titleElement: (
            <Typography intrinsic="h3" iconColor="blue" icon={<FaGraduationCap />} iconFilled iconSize={20}>
                Module de formation
            </Typography>
        ),
        customNavigate: '/sante-securite'
    },
    '/sante-securite/formations/list': {
        titleElement: (
            <Typography intrinsic="h3" iconColor="blue" icon={<FaGraduationCap />} iconFilled iconSize={20}>
                Module de formation
            </Typography>
        ),
        customNavigate: '/sante-securite'
    },
    '/sante-securite/epi': {
        titleElement: (
            <Typography intrinsic="h3" iconColor="blue" icon={<IoBagHandleSharp />} iconFilled iconSize={20}>
                Demande d'EPI
            </Typography>
        ),
        hasFavorite: true
    },
    '/sante-securite/epi/cart': {
        titleElement: (
            <Typography intrinsic="h3" iconColor="blue" icon={<FaShoppingBasket />} iconFilled iconSize={20}>
                Mon panier EPI
            </Typography>
        )
    },
    '/sante-securite/epi/orders': {
        titleElement: (
            <Typography intrinsic="h3" iconColor="blue" icon={<FaShoppingCart />} iconFilled iconSize={20}>
                Mes commandes EPI
            </Typography>
        )
    },
    '/sante-securite/epi/orders/favorites': {
        titleElement: (
            <Typography intrinsic="h3" iconColor="blue" icon={<FaStar />} iconFilled iconSize={20}>
                Mes paniers favoris EPI
            </Typography>
        )
    },
    '/sante-securite/golden-rules': {
        titleElement: (
            <Typography intrinsic="h3" iconColor="blue" icon={<PiMedalFill />} iconFilled iconSize={20}>
                Règles d'Or
            </Typography>
        ),
        customNavigate: '/sante-securite',
        hasFavorite: true
    },
    '/sante-securite/home-security': {
        titleElement: (
            <Typography intrinsic="h3" iconColor="blue" icon={<IoShieldCheckmarkSharp />} iconFilled iconSize={20}>
                Accueil sécurité
            </Typography>
        ),
        hasFavorite: true,
        customNavigate: '/sante-securite'
    },
    '/sante-securite/home-security/emargement': {
        titleElement: (
            <Typography intrinsic="h3" iconColor="blue" icon={<IoShieldCheckmarkSharp />} iconFilled iconSize={20}>
                Accueil sécurité - Émargement
            </Typography>
        ),
        customNavigate: '/sante-securite'
    },
    '/sante-securite/home-security/minor-infos': {
        titleElement: (
            <Typography intrinsic="h3" iconColor="blue" icon={<IoShieldCheckmarkSharp />} iconFilled iconSize={20}>
                Personne mineure
            </Typography>
        ),
        customNavigate: '/sante-securite/home-security'
    },
    '/sante-securite/home-security/menu': {
        titleElement: (
            <Typography intrinsic="h3" iconColor="blue" icon={<IoShieldCheckmarkSharp />} iconFilled iconSize={20}>
                Accueil sécurité
            </Typography>
        ),
        customNavigate: '/sante-securite'
    },
    '/sante-securite/home-security/tools': {
        titleElement: (
            <Typography intrinsic="h3" iconColor="blue" icon={<IoShieldCheckmarkSharp />} iconFilled iconSize={20}>
                Accueil sécurité
            </Typography>
        ),
        customNavigate: 'sante-securite/home-security/menu'
    },
    '/sante-securite/home-security/worksite-presentation': {
        titleElement: (
            <Typography intrinsic="h3" iconColor="blue" icon={<IoShieldCheckmarkSharp />} iconFilled iconSize={20}>
                Accueil sécurité
            </Typography>
        ),
        customNavigate: 'sante-securite/home-security/menu'
    },
    '/sante-securite/home-security/epis': {
        titleElement: (
            <Typography intrinsic="h3" iconColor="blue" icon={<IoShieldCheckmarkSharp />} iconFilled iconSize={20}>
                Accueil sécurité
            </Typography>
        ),
        customNavigate: 'sante-securite/home-security/menu'
    },
    '/sante-securite/home-security/formation': {
        titleElement: (
            <Typography intrinsic="h3" iconColor="blue" icon={<IoShieldCheckmarkSharp />} iconFilled iconSize={20}>
                Accueil sécurité
            </Typography>
        ),
        customNavigate: 'sante-securite/home-security/menu'
    },
    '/sante-securite/home-security/risks': {
        titleElement: (
            <Typography intrinsic="h3" iconColor="blue" icon={<IoShieldCheckmarkSharp />} iconFilled iconSize={20}>
                Accueil sécurité
            </Typography>
        ),
        customNavigate: 'sante-securite/home-security/menu'
    },
    '/sante-securite/home-security/withdrawal': {
        titleElement: (
            <Typography intrinsic="h3" iconColor="blue" icon={<IoShieldCheckmarkSharp />} iconFilled iconSize={20}>
                Accueil sécurité
            </Typography>
        ),
        customNavigate: 'sante-securite/home-security/menu'
    },
    '/sante-securite/security-audit': {
        titleElement: (
            <Typography intrinsic="h3" iconColor="blue" icon={<HiMiniDocumentMagnifyingGlass />} iconFilled iconSize={20}>
                Visite de sécurité
            </Typography>
        ),
        customNavigate: '/sante-securite',
        hasFavorite: true
    },
    '/sante-securite/ppsps': {
        titleElement: (
            <Typography intrinsic="h3" iconColor="blue" icon={<HiClipboardDocumentList />} iconFilled iconSize={20}>
                PPSPS
            </Typography>
        ),
        hasFavorite: true,
        customNavigate: '/sante-securite'
    },
    '/mes-chantiers': {
        titleElement: <Typography intrinsic="h2">Mes chantiers</Typography>,
        customNavigate: '/home'
    },
    '/mes-chantiers/approvisionnement': {
        titleElement: (
            <Typography intrinsic="h3" iconColor="red" icon={<IoBagHandleSharp />} iconFilled iconSize={20}>
                Approvisionnement
            </Typography>
        ),
        hasFavorite: true,
        customNavigate: '/mes-chantiers'
    },
    '/mes-chantiers/approvisionnement/cart': {
        titleElement: (
            <Typography intrinsic="h3" iconColor="red" icon={<FaShoppingBasket />} iconFilled iconSize={20}>
                Mon panier
            </Typography>
        ),
        customNavigate: '/mes-chantiers/approvisionnement'
    },
    '/mes-chantiers/approvisionnement/orders': {
        titleElement: (
            <Typography intrinsic="h3" iconColor="red" icon={<FaShoppingCart />} iconFilled iconSize={20}>
                Mes commandes
            </Typography>
        ),
        customNavigate: '/mes-chantiers/approvisionnement'
    },
    '/mes-chantiers/approvisionnement/orders/favorites': {
        titleElement: (
            <Typography intrinsic="h3" iconColor="red" icon={<FaStar />} iconFilled iconSize={20}>
                Mes paniers favoris
            </Typography>
        ),
        customNavigate: '/mes-chantiers/approvisionnement'
    },
    '/mes-chantiers/event-feedback': {
        titleElement: (
            <Typography intrinsic="h3" iconColor="red" icon={<FaTriangleExclamation />} iconFilled iconSize={20}>
                Remontée d'évènement
            </Typography>
        ),
        customNavigate: '/mes-chantiers'
    },
    '/mes-chantiers/quitus': {
        titleElement: (
            <Typography intrinsic="h3" iconColor="red" icon={<BsClipboard2CheckFill />} iconFilled iconSize={20}>
                Levée de réserve et quitus
            </Typography>
        ),
        hasFavorite: true,
        customNavigate: '/mes-chantiers'
    },
    '/mes-chantiers/quitus/new': {
        titleElement: (
            <Typography intrinsic="h3" iconColor="red" icon={<BsClipboard2CheckFill />} iconFilled iconSize={20}>
                Nouveau quitus
            </Typography>
        )
    },
    '/mes-chantiers/my-worksite-results': {
        titleElement: (
            <Typography intrinsic="h3" iconColor="red" icon={<BiSolidBarChartAlt2 />} iconFilled iconSize={20}>
                Mes résultats de chantier
            </Typography>
        ),
        hasFavorite: true,
        customNavigate: '/mes-chantiers'
    },
    '/mes-chantiers/worksite-results': {
        titleElement: (
            <Typography intrinsic="h3" iconColor="red" icon={<BiSolidBarChartAlt2 />} iconFilled iconSize={20}>
                Mes résultats de chantier
            </Typography>
        ),
        customNavigate: '/mes-chantiers/my-worksite-results'
    },
    '/mes-chantiers/bibliotheque': {
        titleElement: (
            <Typography intrinsic="h3" iconColor="red" icon={<IoLibrary />} iconFilled iconSize={20}>
                Bibliothèque chantier
            </Typography>
        ),
        hasFavorite: true,
        customNavigate: '/mes-chantiers'
    },
    '/mes-chantiers/testsheets': {
        titleElement: (
            <Typography intrinsic="h3" iconColor="red" icon={<HiMiniDocumentMagnifyingGlass />} iconFilled iconSize={20}>
                Essai / AQC
            </Typography>
        ),
        hasFavorite: true,
        customNavigate: '/mes-chantiers'
    }
};

// Backup titles
// '/mes-chantiers/event-feedback-problem': {
//     titleElement: (
//         <Typography intrinsic="h3" iconColor="red" icon={<FaTriangleExclamation />} iconFilled iconSize={20}>
//             Remontée d'un problème
//         </Typography>
//     ),
//     customNavigate: '/mes-chantiers'
// },
// '/mes-chantiers/event-feedback-problem/pieuvre': {
//     titleElement: (
//         <Typography intrinsic="h3" iconColor="red" icon={<FaTriangleExclamation />} iconFilled iconSize={20}>
//             Nouvelle Pieuvre
//         </Typography>
//     ),
//     customNavigate: '/mes-chantiers/event-feedback-problem'
// },
// '/mes-chantiers/event-feedback-problem/retour-produit': {
//     titleElement: (
//         <Typography intrinsic="h3" iconColor="red" icon={<FaTriangleExclamation />} iconFilled iconSize={20}>
//             Retour de produit
//         </Typography>
//     ),
//     customNavigate: '/mes-chantiers/event-feedback-problem'
// },
